module.exports = __webpack_public_path__ + "img/expiration-alerts.d7c55f8b.jpg";